import {
  MAutocomplete,
  ResponsiveFormContainer,
  MTextField,
  MDatePicker,
} from "@app/components";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import {
  useDetector,
  useEquipment,
  useEquipmentMide,
  useUser,
} from "@services/servicesGenericsTables";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";

import React, { useMemo, useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";

const CountingPuAmCM = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const { currentCounting } = useAnalysis();
  const filteredProcedures = useFilteredProcedures("CON");
  const { loading } = useEquipmentMide();
  const { detectorsList } = useDetector();

  const [openModal, setOpenModal] = useState(false);
  const [previousUnit, setPreviousUnit] = useState(null);
  const isFirstChange = form.watch("isFirstChange");

  const watchEquipment = form.watch("counting_equipment");

  const unitTypesValue = form.watch("unit_types");

  const filterDetectors = useMemo(() => {
    const idsEquipment = watchEquipment?.map((e) => e.id);
    return detectorsList.filter(
      (detector) => idsEquipment?.includes(detector.equipment.id) || false
    );
  }, [watchEquipment, detectorsList]);

  // Detectar el cambio solo cuando el valor de unit_types cambie
  useEffect(() => {
    if (isFirstChange || isFirstChange !== undefined) {
      setOpenModal(false);
      setPreviousUnit(unitTypesValue.codigo);
    }

    if (unitTypesValue?.codigo !== previousUnit && previousUnit !== null) {
      setOpenModal(true);
      setPreviousUnit(unitTypesValue.codigo);
    }
  }, [unitTypesValue]);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleConfirmChange = () => {
    setOpenModal(false);
  };

  return (
    <>
      {currentCounting.index !== undefined ? (
        <React.Fragment key={currentCounting.id}>
          <ResponsiveFormContainer columns={5}>
            <MAutocomplete
              name="analyst"
              options={userList}
              label="Seleccione un analista"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista es requerido" }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              name="counting_procedure"
              options={filteredProcedures}
              label="Procedimiento MLPMA"
              getOptionLabel={(option) => `${option.numop}` || ""}
              validation={{
                required:
                  filteredProcedures?.length > 0
                    ? "La parte es requerida"
                    : false,
              }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              key={`counting_equipment-${form.getValues("counting_equipment")}`}
              name="counting_equipment"
              options={equipmentList}
              label="Seleccione un Equipo"
              getOptionLabel={(option) =>
                `${option.codigo} - ${option.descripcion}` || ""
              }
              multiple
              loading={loading}
              disabled={!currentCounting.canEdit}
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("counting_detector"))}
              name="counting_detector"
              options={filterDetectors}
              label="Detector"
              getOptionLabel={(option) => `${option.name}` || ""}
              multiple
              disabled={!currentCounting.canEdit}
            />
            <MDatePicker
              key="counting_date"
              name="counting_date"
              pickerType="date"
              label="Fecha de contaje"
              validation={{
                required: "La fecha de contaje es requerida",
              }}
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="counting_valid"
              placeholder="Contaje Válido"
              label="Contaje Válido"
              type="text"
              fullWidth
              disabled
              InputProps={{ style: { color: "gray" } }}
            />
          </ResponsiveFormContainer>

          {/* Modal para mostrar la alerta */}
          <Dialog open={openModal} onClose={handleCloseModal}>
            <DialogTitle>Alerta</DialogTitle>
            <DialogContent>
              <p>Va a cambiar la unidad de la muestra</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseModal} color="primary">
                Cancelar
              </Button>
              <Button onClick={handleConfirmChange} color="primary">
                Aceptar
              </Button>
            </DialogActions>
          </Dialog>
        </React.Fragment>
      ) : null}
    </>
  );
};

export default CountingPuAmCM;
